/**
 * Detect if the current device/platform supports Apple Wallet
 * Apple Wallet works best on iOS, but .pkpass files can be downloaded on any platform
 */
export function isAppleWalletSupported(): boolean {
  if (typeof window === 'undefined') return false;
  
  // Show Apple Wallet button on all platforms
  // On iOS Safari, it will automatically open Wallet
  // On other platforms, users can download the .pkpass file
  return true;
}

/**
 * Detect if the current device/platform supports Google Wallet
 */
export function isGoogleWalletSupported(): boolean {
  if (typeof window === 'undefined') return false;
  
  // Google Wallet works on all platforms via web
  return true;
}

import { getApiBaseUrl } from '../api/config';

/**
 * Add voucher to Apple Wallet
 */
export async function addToAppleWallet(voucherCode: string): Promise<void> {
  const apiBaseUrl = getApiBaseUrl();
  const url = `${apiBaseUrl}/gift-vouchers/public/${encodeURIComponent(voucherCode)}/wallet/apple`;
  
  try {
    // First check if Apple Wallet is configured by making a HEAD request
    const checkResponse = await fetch(url, { method: 'HEAD' });
    
    if (!checkResponse.ok) {
      const errorData = await fetch(url).then(r => r.json()).catch(() => ({}));
      if (errorData.error?.code === 'service_unavailable') {
        throw new Error('Apple Wallet is not yet configured. Please use PDF download or Google Wallet instead.');
      }
      throw new Error(errorData.error?.message || 'Failed to add to Apple Wallet');
    }
    
    // If configured, trigger the download
    // For iOS Safari, the browser will handle .pkpass files automatically
    window.location.href = url;
  } catch (error: any) {
    console.error('Error adding to Apple Wallet:', error);
    throw error;
  }
}

/**
 * Add voucher to Google Wallet
 */
export async function addToGoogleWallet(voucherCode: string): Promise<string> {
  const apiBaseUrl = getApiBaseUrl();
  const url = `${apiBaseUrl}/gift-vouchers/public/${encodeURIComponent(voucherCode)}/wallet/google`;
  
  try {
    // Try POST first (returns JSON with wallet_url)
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      // If POST fails, try GET (redirects directly)
      window.location.href = url;
      return url;
    }

    const data = await response.json();
    return data.wallet_url || url;
  } catch (error) {
    console.error('Error adding to Google Wallet:', error);
    // Fallback to GET redirect
    window.location.href = url;
    return url;
  }
}

